import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Label,
    Row,
} from "reactstrap";

import CommonTable from "../../../components/Common/TableContainer";
import Select from "react-select";
import AllCommonFilterModal from "pages/AllCommonFilter/all-common-filter";


const ComplianceReport = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [commonFilterModalOpen, setCommonFilterModalOpen] = useState(true);

    const columns = [
        { Header: "Candidate", accessor: "Candidate" },
        { Header: "Client", accessor: "client" },
        { Header: "Document Type", accessor: "document_type" },
        { Header: "Expiry Date", accessor: "expiry_date" },

    ];

    const jobCategoryData = [
        { Candidate: "LOGAN CORDY", client: "Neville Express Inc.", document_type: "MEC", expiry_date: "12-28-2025" },
        { Candidate: "TYRELL MYERS", client: "Routewise Logisitics Inc", document_type: "MEC", expiry_date: "01-01-2026" },
    ];

    // Filtering only when search button is pressed
    const filteredData = useMemo(() => {
        if (!searchQuery.trim()) return jobCategoryData;

        return jobCategoryData.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                        <Label className="fs-5"><strong>Compliancy Report</strong></Label>

                            <CommonTable columns={columns} data={filteredData} isActionRequired={false} />
                        </CardBody>
                    </Card>


                </Container>
            </div>
            <AllCommonFilterModal setCommonFilterModalOpen={setCommonFilterModalOpen} commonFilterModalOpen={commonFilterModalOpen} modalTitle="Leads Added Report"/>
        </React.Fragment>
    );
};

ComplianceReport.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(ComplianceReport);
